<template>
  <div>
    <b-form-select
      v-model="scopeFilter"
      :options="scopeOptions"
      class="mb-3 admin-snippets-scope-filter"
    />
    <b-table
      :items="filteredRows"
      :fields="fields"
      hover
      responsive
      show-empty
      :empty-text="$t('webmag.emptyFilteredText')"
    >
      <template #cell(preview)="{ item }">
        <img
          v-if="item.data && item.data.preview"
          :src="thumbUrl(item.data.preview)"
          class="admin-snippet-thumb"
          alt=""
        />
      </template>
      <template #cell(title)="{ item }">
        <div>{{ item.data && item.data.title_de }}</div>
        <div class="text-muted small">{{ item.data && item.data.title_en }}</div>
      </template>
      <template #cell(scope)="{ item }">
        {{ item.group_id === null ? 'Global' : (item.group ? item.group.name : item.group_id) }}
      </template>
      <template #cell(status)="{ item }">
        <b-badge :variant="item.data && item.data.active === false ? 'warning' : 'success'">
          {{ item.data && item.data.active === false ? 'Draft' : 'Active' }}
        </b-badge>
      </template>
      <template #cell(categories)="{ item }">
        {{ (item.data && item.data.categories || []).join(', ') }}
      </template>
      <template #cell(tags)="{ item }">
        {{ item.snippets_v2_tags.map((st) => st.tag.name).join(', ') }}
      </template>
      <template #cell(actions)="{ item }">
        <b-button size="sm" variant="outline-primary" @click="$emit('edit-snippet', item)">
          <b-icon icon="pencil" />
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          class="ml-2"
          title="Duplicate"
          @click="$emit('duplicate-snippet', item)"
        >
          <b-icon icon="files" />
        </b-button>
        <b-button size="sm" variant="outline-danger" class="ml-2" @click="$emit('delete-snippet', item)">
          <b-icon icon="trash" />
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'AdminSnippetsTable',
  props: {
    snippets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      scopeFilter: 'all',
      fields: [
        { key: 'preview', label: '' },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'title', label: 'Title (de/en)' },
        { key: 'scope', label: 'Scope' },
        { key: 'status', label: 'Status' },
        { key: 'categories', label: 'Categories' },
        { key: 'tags', label: 'Tags' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    scopeOptions() {
      const groups = new Map();
      this.snippets.forEach((s) => {
        if (s.group_id !== null) {
          groups.set(s.group_id, s.group ? s.group.name : `Group ${s.group_id}`);
        }
      });
      return [
        { value: 'all', text: 'All' },
        { value: 'global', text: 'Global' },
        ...Array.from(groups.entries()).map(([value, text]) => ({ value, text })),
      ];
    },
    filteredRows() {
      if (this.scopeFilter === 'all') return this.snippets;
      if (this.scopeFilter === 'global') return this.snippets.filter((s) => s.group_id === null);
      return this.snippets.filter((s) => s.group_id === this.scopeFilter);
    },
  },
  methods: {
    // Thumbs are stored as raw S3 URLs — serve a small CDN variant here
    // (transform is a no-op for non-S3 URLs).
    thumbUrl(preview) {
      const bunnyUrl = this.$transformS3ToBunnyUrl(preview);
      if (bunnyUrl !== preview) {
        const sep = bunnyUrl.includes('?') ? '&' : '?';
        return `${bunnyUrl}${sep}width=160&quality=85`;
      }
      return preview;
    },
  },
};
</script>

<style scoped>
.admin-snippet-thumb {
  max-width: 80px;
  max-height: 48px;
  object-fit: cover;
  border-radius: 4px;
}
.admin-snippets-scope-filter {
  max-width: 300px;
}
</style>
